<script>
  import { External, M } from '../../../../../external';
  import Order from '../../../../../Store/Order.svelte';
  import { ignore } from '../../../../../Common/tools';
  import AbandonedOrderDetails from '../../../../../Store/AbandonedOrderDetails.svelte';

  export let data = { order: { id: -1, invoiceNo: -1, status: '', total: 0 } },
    contact;

  const id = data.order?.id || -1;
  const invoiceNo = data.order?.invoiceNo || -1;
  const status = data.order?.status || '';
  const total = data.order?.total || 0;
  const currency = data.order?.currency || '';

  const orderClicked = () => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      noNav: true,
      noTitle: true,
      width: 1200,
      forceAtRight: true, //External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup) => {
          if (status === 'abandoned') {
            popup.bindComponent(
              new AbandonedOrderDetails({
                target: popup.getContentArea(),
                props: {
                  id: id
                }
              })
            );
          } else {
            popup.bindComponent(
              new Order({
                target: popup.getContentArea(),
                props: {
                  id: id,
                  options: {
                    inPopup: true
                  }
                }
              })
            );
          }
        },
        onBeforeHide: (popup, ui, closeAction) => {
          if (popup.component().isChanged && popup.component().isChanged()) {
            External.CPanel.showUnsavedChangesPrompt(() => {
              closeAction();
            }, ignore);
            return false;
          }
        }
      }
    });
  };
</script>

<b>
  <a on:click={orderClicked} class="blue-text">#{invoiceNo || id}</a> - {External.Tools.currencyToStrWithSymbol(
    total,
    currency
  )} - {M[`ORDER_STATUS_${status.toUpperCase()}`]}
</b>
